export const GROUP_ERRORS = {
	NOT_FOUND: "group_not_found",
	NAME_TAKEN: "group_name_taken",
	NOT_MEMBER: "not_group_member",
	ALREADY_MEMBER: "already_group_member",
	SELF_JOIN_DISABLED: "group_self_join_disabled",
	FAILED_TO_CREATE_GROUP: "failed_to_create_group",
	FAILED_TO_UPDATE_GROUP: "failed_to_update_group",
	NOT_COMMUNITY_MEMBER: "not_community_member",
	REQUEST_PENDING: "request_pending",
	REQUEST_NOT_FOUND: "request_not_found",
	REQUEST_ALREADY_DECIDED: "request_already_decided",
	GROUP_IS_OPEN: "group_is_open",
} as const;

export type GroupErrorCode = (typeof GROUP_ERRORS)[keyof typeof GROUP_ERRORS];
